import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaConfiguracionColaboradoresDescuentosConceptos', NominasNominaConfiguracionColaboradoresDescuentosConceptos)

function NominasNominaConfiguracionColaboradoresDescuentosConceptos($http) {
  this.get = function (idProyecto, idNomina) {
    return $http.get('/api/nominas/nomina/configuracion/colaboradores/descuentos/conceptos', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
      },
      schema: this.schema,
    })
  }.bind(this)

  this.put = function (idProyecto, idNomina, data) {
    return $http.put('/api/nominas/nomina/configuracion/colaboradores/descuentos/conceptos', data, {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
      },
      schema: this.schema,
      clearCache: 'nominas',
    })
  }.bind(this)

  this.schema = {
    activo: 'boolean',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Configuracion/Colaboradores/Descuentos/Conceptos.js